<template>
  <v-row>
    <v-col>
      <h2 class="py-3 mb-3">Teacher Attendace {{ calendar_date_range ? 'From '+formatDate(calendar_date_range[0]) + ' - Till '+ ((calendar_date_range[1] == undefined) ? '' : formatDate(calendar_date_range[1])) : null   }}</h2>
      <hr class="mb-8" />
      <v-data-table
        :headers="headers"
        :items="list"
        :options.sync="options"
        :server-items-length="items_length"
        :loading="loading"
        :sort-by="headers[0].value"
        class="elevation-1"
      >
        <template v-slot:no-data>
          <p class="mt-5 mb-5">
            No Result Found
            <v-btn
              @click="initialize"
              class="mx-2"
              fab
              dark
              small
              color="primary"
            >
              <v-icon dark> mdi-refresh </v-icon>
            </v-btn>
          </p>
        </template>
        <template v-slot:footer>
          <div class="hour_attended_div mt-5 mb-5">
            <p class="hour_attended">
              <strong>Total Hours Attended: </strong>{{ total_hour_attended }}
            </p>
          </div>
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>

<script>
import moment from "moment";

export default {
  name: "tutor-attendance-report",
  props: {
    tutor_id: {
      default: null,
    },
    calendar_date_range: {
      default: null,
    },
  },
  computed: {
    detail() {
      return this.calendar_date_range == null
        ? "Table (Oveview)"
        : (typeof this.calendar_date_range[0] !== "undefined" &&
          this.calendar_date_range[0] !== null
            ? "From " + this.calendar_date_range[0]
            : "") +
            " - " +
            (typeof this.calendar_date_range[1] != "undefined" &&
            this.calendar_date_range[1] !== null
              ? "Till " + this.calendar_date_range[1]
              : "");
    },
  },
  data() {
    return {
      total_hour_attended: 0,
      list: [],
      headers: [],
      loading: false,
      items_length: 0,
      options: {
        page: 1,
        itemsPerPage: 5,
        sortBy: ["std_id"],
        sortDesc: [false],
        groupBy: [],
        groupDesc: [],
        mustSort: false,
        multiSort: false,
      },
    };
  },
  watch: {
    options: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
  },
  methods: {
      formatDate(date) {
      return moment(date, "DD-MMM-YYYY", true).isValid()
        ? date
        : moment(date).format("DD-MM-YYYY");
    },
    dateSwaperFrom:function(){
      if(this.calendar_date_range == 2){
          if(new Date(this.calendar_date_range[0]) > new Date(this.calendar_date_range[1])){
             return this.calendar_date_range[1];
          }else{
            return this.calendar_date_range[0];
          }
      }else{
       
        return this.calendar_date_range[0];
      }
    },
    dateSwaperAfter:function(){
      if(this.calendar_date_range == 2){
          if(new Date(this.calendar_date_range[1]) > new Date(this.calendar_date_range[0])){
             return this.calendar_date_range[1];
          }else{
            return this.calendar_date_range[0];
          }
      }else{
       
        return this.calendar_date_range[1];
      }
       
    },
    calculateTotalHours(array) {
       this.total_hour_attended = 0;
      for (let index = 0; index < array.length; index++) {
        console.log("array[index].hours_attended", array[index].hours_attended);
        this.total_hour_attended += array[index].hours_attended;
      }
    },
    initialize() {
      this.total_hour_attended = 0;
      // if (this.tutor_id !== null) {
      this.loading = true;
      this.options.type = "tutor";
      this.options.id = this.tutor_id;

      if(this.calendar_date_range.length == 2){
          if(new Date(this.calendar_date_range[0]) > new Date(this.calendar_date_range[1])){
              let a = this.calendar_date_range[0];
              let b = this.calendar_date_range[1]
              this.calendar_date_range[0]=b;
              this.calendar_date_range[1]=a;
          }
      }

      this.options.calendar_date_range = this.calendar_date_range;
      axios
        .post(apiRoutes.reports.getReport, {
          params: this.options,
        })
        .then((response) => {
          if (response.data.state == "success") {
            this.list = response.data.data.data;
            this.items_length = response.data.data.total;
            this.headers = response.data.data.headers;

            this.loading = false;
            this.calculateTotalHours(response.data.data.data);
          }
        });
      // }
    },
  },
  mounted() {
    this.initialize();
  },
};
</script>

<style scoped>
.hour_attended_div {
  height: 25px;
}
.hour_attended {
  float: right;
  margin-bottom: 0px;
  margin-right: 15px;
  font-size: 15px;
}
</style>
